// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stacked-cards {
  position: relative;
  display: flex;
  align-items: center;
  gap: 6px;
}
.stacked-cards .left-click, .stacked-cards .right-click {
  border-radius: 32px;
  background: var(--sdk-global-white-bg);
  box-shadow: 0px 4px 12px 2px rgba(32, 33, 36, 0.12);
  display: flex;
  width: 32px;
  height: 32px;
  padding: 10px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border: 0;
  cursor: pointer;
  flex-shrink: 0;
  position: relative;
  z-index: 99;
}
.stacked-cards .left-click.disabled-click, .stacked-cards .disabled-click.right-click {
  display: none;
  color: #D7D8D9;
  pointer-events: none;
  cursor: no-drop;
}
.stacked-cards ul {
  position: relative;
  width: 100%;
  display: flex;
  margin: 0;
  padding: 0;
  height: 200px !important;
}
.stacked-cards ul li {
  cursor: pointer;
  list-style: none;
  width: 65%;
  position: absolute;
  left: 50%;
  transition: 0.5s ease transform;
}
.stacked-cards ul li.active {
  cursor: default;
  transition: 0.5s ease transform;
}

.stacked-cards li:after {
  bottom: 0;
  content: "";
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  display: none;
}

.list-template-carousel-wrapper {
  display: flex;
  align-items: center;
  position: relative;
  gap: 10px;
  padding: 6px 12px;
}
.list-template-carousel-wrapper .carousel-left-click, .list-template-carousel-wrapper .carousel-right-click {
  position: absolute;
  border-radius: 32px;
  background: var(--sdk-global-white);
  box-shadow: 0px 4px 12px 2px rgba(32, 33, 36, 0.12);
  display: flex;
  width: 32px;
  height: 32px;
  padding: 10px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border: 0;
  left: 20px;
  top: auto;
  cursor: pointer;
  flex-shrink: 0;
  z-index: 9;
}
.list-template-carousel-wrapper .carousel-left-click svg path, .list-template-carousel-wrapper .carousel-right-click svg path {
  stroke: var(--sdk-gloabl-text-color);
}
.list-template-carousel-wrapper .carousel-left-click.hide, .list-template-carousel-wrapper .hide.carousel-right-click {
  display: none;
}
.list-template-carousel-wrapper .carousel-right-click {
  left: auto;
  right: 20px;
}
.list-template-carousel-wrapper .list-carousel {
  display: flex;
  overflow: hidden;
  gap: 10px;
}
.list-template-carousel-wrapper .list-carousel .list-carousel-item {
  display: flex;
  padding: 8px;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  border-radius: 4px;
  border: 1px solid var(--sdk-gloabl-border-color);
  background: var(--sdk-global-white-bg);
  flex: 1;
  max-width: 255px;
  min-width: 255px;
  word-break: break-word;
}
.list-template-carousel-wrapper .list-carousel .list-carousel-item .img-block {
  width: 100%;
  height: 144px;
}
.list-template-carousel-wrapper .list-carousel .list-carousel-item .img-block figure {
  width: 100%;
  height: 144px;
}
.list-template-carousel-wrapper .list-carousel .list-carousel-item .img-block figure img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 4px;
}
.list-template-carousel-wrapper .list-carousel .list-carousel-item .content-block {
  display: flex;
  padding: 8px;
  align-items: flex-start;
  gap: 12px;
  align-self: stretch;
  flex-direction: column;
}
.list-template-carousel-wrapper .list-carousel .list-carousel-item .content-block .heading-block {
  display: flex;
  align-items: center;
  width: 100%;
  gap: 8px;
}
.list-template-carousel-wrapper .list-carousel .list-carousel-item .content-block .heading-block h1 {
  color: var(--sdk-gloabl-text-color);
  font-size: 14px;
  font-weight: 700;
  line-height: normal;
  width: 100%;
}
.list-template-carousel-wrapper .list-carousel .list-carousel-item .content-block .heading-block p {
  color: var(--success-600, #16A34A);
  text-align: center;
  font-size: 11px;
  font-weight: 600;
  line-height: 16px;
}
.list-template-carousel-wrapper .list-carousel .list-carousel-item .content-block .link-exteranl-site {
  color: var(--sdk-global-theme-color);
  font-size: 12px;
  font-weight: 400;
  line-height: normal;
  text-decoration: none;
  cursor: pointer;
}
.list-template-carousel-wrapper .list-carousel .list-carousel-item .content-block p {
  overflow: hidden;
  color: var(--sdk-gloabl-text-color);
  text-overflow: ellipsis;
  font-size: 12px;
  font-weight: 400;
  line-height: normal;
}
.list-template-carousel-wrapper .list-carousel .list-carousel-item .content-block .rating-block {
  display: flex;
  align-items: center;
  gap: 6px;
}
.list-template-carousel-wrapper .list-carousel .list-carousel-item .content-block .rating-block figure {
  line-height: 0;
}`, "",{"version":3,"sources":["webpack://./src/templatemanager/templates/carouselTemplate/carouselTemplate.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AACJ;AACI;EACI,mBAAA;EACA,sCAAA;EACA,mDAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,SAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;AACR;AACQ;EACI,aAAA;EACA,cAAA;EACA,oBAAA;EACA,eAAA;AACZ;AAOI;EACI,kBAAA;EACA,WAAA;EACA,aAAA;EACA,SAAA;EACA,UAAA;EACA,wBAAA;AALR;AAOQ;EACI,eAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,SAAA;EACA,+BAAA;AALZ;AAOY;EACI,eAAA;EACA,+BAAA;AALhB;;AAYA;EACI,SAAA;EACA,WAAA;EACA,OAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,aAAA;AATJ;;AAYA;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,iBAAA;AATJ;AAWI;EACI,kBAAA;EACA,mBAAA;EACA,mCAAA;EACA,mDAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;EACA,cAAA;EACA,UAAA;AATR;AAWY;EACI,oCAAA;AAThB;AAYQ;EACG,aAAA;AAVX;AAcI;EAEI,UAAA;EACA,WAAA;AAbR;AAgBI;EACI,aAAA;EACA,gBAAA;EACA,SAAA;AAdR;AAgBQ;EACI,aAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,gDAAA;EACA,sCAAA;EAGA,OAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;AAhBZ;AAiBY;EACI,WAAA;EACA,aAAA;AAfhB;AAiBgB;EACI,WAAA;EACA,aAAA;AAfpB;AAiBoB;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AAfxB;AAoBY;EACI,aAAA;EACA,YAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;EACA,sBAAA;AAlBhB;AAoBgB;EACI,aAAA;EACA,mBAAA;EACA,WAAA;EACA,QAAA;AAlBpB;AAoBoB;EACI,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;AAlBxB;AAqBoB;EACI,kCAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAnBxB;AAuBgB;EACI,oCAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,eAAA;AArBpB;AAwBgB;EACI,gBAAA;EACA,mCAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAtBpB;AAyBgB;EACI,aAAA;EACA,mBAAA;EACA,QAAA;AAvBpB;AAyBoB;EACI,cAAA;AAvBxB","sourcesContent":[".stacked-cards {\n    position: relative;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n\n    .left-click {\n        border-radius: 32px;\n        background: var(--sdk-global-white-bg);\n        box-shadow: 0px 4px 12px 2px rgba(32, 33, 36, 0.12);\n        display: flex;\n        width: 32px;\n        height: 32px;\n        padding: 10px;\n        justify-content: center;\n        align-items: center;\n        gap: 10px;\n        border: 0;\n        cursor: pointer;\n        flex-shrink: 0;\n        position: relative;\n        z-index: 99;\n\n        &.disabled-click {\n            display: none;\n            color: #D7D8D9;\n            pointer-events: none;\n            cursor: no-drop;\n        }\n    }\n\n    .right-click {\n        @extend .left-click;\n    }\n\n    ul {\n        position: relative;\n        width: 100%;\n        display: flex;\n        margin: 0;\n        padding: 0;\n        height: 200px !important;\n\n        li {\n            cursor: pointer;\n            list-style: none;\n            width: 65%;\n            position: absolute;\n            left: 50%;\n            transition: 0.5s ease transform;\n\n            &.active {\n                cursor: default;\n                transition: 0.5s ease transform;\n            }\n        }\n    }\n}\n\n\n.stacked-cards li:after {\n    bottom: 0;\n    content: \"\";\n    left: 0;\n    position: absolute;\n    right: 0;\n    top: 0;\n    display: none;\n}\n\n.list-template-carousel-wrapper {\n    display: flex;\n    align-items: center;\n    position: relative;\n    gap: 10px;\n    padding: 6px 12px;\n\n    .carousel-left-click {\n        position: absolute;\n        border-radius: 32px;\n        background: var(--sdk-global-white);\n        box-shadow: 0px 4px 12px 2px rgba(32, 33, 36, 0.12);\n        display: flex;\n        width: 32px;\n        height: 32px;\n        padding: 10px;\n        justify-content: center;\n        align-items: center;\n        gap: 10px;\n        border: 0;\n        left: 20px;\n        top: auto;\n        cursor: pointer;\n        flex-shrink: 0;\n        z-index: 9;\n        svg{\n            path{\n                stroke: var(--sdk-gloabl-text-color);\n            }\n        }\n        &.hide {\n           display: none;\n        }\n    }\n\n    .carousel-right-click {\n        @extend .carousel-left-click;\n        left: auto;\n        right: 20px;\n    }\n\n    .list-carousel {\n        display: flex;\n        overflow: hidden;\n        gap: 10px;\n\n        .list-carousel-item {\n            display: flex;\n            padding: 8px;\n            flex-direction: column;\n            align-items: flex-start;\n            gap: 12px;\n            border-radius: 4px;\n            border: 1px solid var(--sdk-gloabl-border-color);\n            background: var(--sdk-global-white-bg);\n            // width: 255px;\n            // flex-shrink: 0;\n            flex: 1;\n            max-width: 255px;\n            min-width: 255px;\n            word-break: break-word;\n            .img-block {\n                width: 100%;\n                height: 144px;\n\n                figure {\n                    width: 100%;\n                    height: 144px;\n\n                    img {\n                        width: 100%;\n                        height: 100%;\n                        object-fit: cover;\n                        border-radius: 4px;\n                    }\n                }\n            }\n\n            .content-block {\n                display: flex;\n                padding: 8px;\n                align-items: flex-start;\n                gap: 12px;\n                align-self: stretch;\n                flex-direction: column;\n\n                .heading-block {\n                    display: flex;\n                    align-items: center;\n                    width: 100%;\n                    gap: 8px;\n\n                    h1 {\n                        color: var(--sdk-gloabl-text-color);\n                        font-size: 14px;\n                        font-weight: 700;\n                        line-height: normal;\n                        width: 100%;\n                    }\n\n                    p {\n                        color: var(--success-600, #16A34A);\n                        text-align: center;\n                        font-size: 11px;\n                        font-weight: 600;\n                        line-height: 16px;\n                    }\n                }\n\n                .link-exteranl-site {\n                    color: var(--sdk-global-theme-color);\n                    font-size: 12px;\n                    font-weight: 400;\n                    line-height: normal;\n                    text-decoration: none;\n                    cursor: pointer;\n                }\n\n                p {\n                    overflow: hidden;\n                    color: var(--sdk-gloabl-text-color);\n                    text-overflow: ellipsis;\n                    font-size: 12px;\n                    font-weight: 400;\n                    line-height: normal;\n                }\n\n                .rating-block {\n                    display: flex;\n                    align-items: center;\n                    gap: 6px;\n\n                    figure {\n                        line-height: 0;\n                    }\n                }\n\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
